import React, { useState } from 'react';
import { IoCloseSharp } from "react-icons/io5";
import { motion } from 'framer-motion';

import ButtonWhite from '../../button/ButtonWhite';
import ButtonBack from '../../button/ButtonBack';
import ModalAlert from '../../modal/ModalAlert'

import { FormatMontoPSE } from '../../../utils/Utils'
import { ReactComponent as Left } from '../../../assets/IconsColurs/IconsGeneral/chevronLeft.svg'
import { IoIosArrowRoundDown } from "react-icons/io";

import COP from '../../../assets/currency/copu.png'
import USD from '../../../assets/currency/usd.png'


const ConfirmPurchase = ({
    tasaForex,
    amountUSD,
    finalAmountCOP,
    Percent,
    contador,
    activeConfimPurchase,
    setActiveConfimPurchase,
    purchaseCommission,
    purchaseCommissionIVA,
    totalPurchase,
    Check,
    setConfirmPurchase,
    confirmPurchase,
    activeCompraFinal,
    setActiveCompraFinal,
    setContador,
    setAmountUSD,
    setActiveEjecutar,
    setAmountCOP,
    setModalOTP
}) => {

    const [loading, setLoading] = useState(false)

    const OnClose = () => {
        setActiveConfimPurchase(false)
    };

    const modalVariants = {
        hidden: { scale: 0, opacity: 0 },
        visible: { scale: 1, opacity: 1, transition: { duration: 0.5, ease: "easeOut" } },
        exit: { scale: 0.8, opacity: 0, transition: { duration: 0.5, ease: "easeInOut" } },
    };


    const closeAllModals = () => {
        setActiveConfimPurchase(false);
        setConfirmPurchase(false);
        setActiveCompraFinal(false)
        setAmountUSD('')
        setActiveEjecutar(true)
        setAmountCOP('')
    };

    return (
        <>

            {activeConfimPurchase && <>
                {confirmPurchase && <ModalAlert title='Transacción exitosa' description='Pronto verás reflejado el monto en tu Saldo Colurs (COP)' labelButtonWhite='Entendido' icon={Check} onClick={closeAllModals} />}
                <div className="fixed inset-0 flex items-center justify-center bg-[#0e0e10] bg-opacity-85 z-50">
                    <motion.div
                        className="bg-[#26262D] rounded-lg shadow-lg w-[90%] max-w-2xl max-h-[90vh] flex flex-col overflow-hidden"
                        variants={modalVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        {/* Header */}
                        <div className="p-6 flex-shrink-0">
                            <div className="w-full flex flex-row justify-between">
                                <p className="text-lg font-semibold text-white">
                                    {'Confirmar la compra'}
                                </p>
                                <IoCloseSharp
                                    size={25}
                                    color={"#b7b7b9"}
                                    onClick={OnClose}
                                    className="cursor-pointer"
                                />
                            </div>
                            <div className="h-[1.5px] w-full bg-[#16161d] mt-4"></div>
                        </div>

                        {/* Content */}
                        <div className="flex-1 px-6 overflow-y-auto">
                            <motion.div
                                className="bg-[#26262D]"
                                key="step2"
                                variants={modalVariants}
                                initial="hidden"
                                animate="visible"
                                exit="exit"
                                transition={{ duration: 0.5, ease: "easeOut" }}
                            >
                                <div className='w-full flex flex-col gap-4 mb-6'>
                                    {/* Exchange Section */}
                                    <div className='w-full bg-[#2B2B33] flex flex-row justify-between rounded-[12px] p-6'>
                                        <div className='w-[40%] flex flex-col gap-2 items-center'>
                                            <img src={USD} alt="img Cop" className='w-[35px] h-[35px]' />
                                            <p className='text-normal text-[#8A8A8E] tracking-[-0.14px] leading-[18.2px] mt-1'>Envías</p>
                                            <p className='font-bold text-[20px] md:text-[22px] text-[#ffffff] tracking-[-0.44px] leading-[28.6px]'>{FormatMontoPSE(amountUSD, false, '.')}</p>
                                        </div>
                                        <div className='w-[20%] flex items-center justify-center'>
                                            <IoIosArrowRoundDown className='rotate-[-90deg] size-12' fill='#ffffff' />
                                        </div>
                                        <div className='w-[40%] flex flex-col gap-2 items-center'>
                                            <img src={COP} alt="img Cop" className='w-[35px] h-[35px]' />
                                            <p className='text-normal text-[#8A8A8E] tracking-[-0.14px] leading-[18.2px] mt-1'>Recibes</p>
                                            <p className='font-bold text-[20px] md:text-[22px] text-[#ffffff] tracking-[-0.44px] leading-[28.6px]'>
                                                {FormatMontoPSE(finalAmountCOP)}</p>
                                        </div>
                                    </div>

                                    {/* Summary Section */}
                                    <div className='w-full flex flex-col gap-2'>
                                        <p className='text-base font-bold tracking-[-0.24px] leading-[15.6px]'>Resumen</p>
                                        <div className='w-full bg-[#2B2B33] p-6 flex flex-col gap-3 rounded-[12px]'>
                                            <div className='flex justify-between items-center'>
                                                <p className='text-[#8A8A8E] tracking-[-0.14px] leading-[18.2px]'>Tasa de intercambio</p>
                                                <p className='font-bold text-white tracking-[-0.44px]'>$1 USD = {FormatMontoPSE(tasaForex, false, ',')}</p>
                                            </div>
                                            <div className='flex justify-between items-center'>
                                                <p className='text-[#8A8A8E] tracking-[-0.14px] leading-[18.2px]'>Monto a enviar</p>
                                                <p className='font-bold text-white tracking-[-0.44px]'>{FormatMontoPSE(amountUSD, false, '.')}</p>
                                            </div>
                                            <div className='flex justify-between items-center'>
                                                <p className='text-[#8A8A8E] tracking-[-0.14px] leading-[18.2px]'>Comisión incluida en tasa</p>
                                                <p className='font-bold text-white tracking-[-0.44px]'>{(Percent)}%</p>
                                            </div>
                                            <div className="border-t border-dashed border-[#8A8A8E] my-2"></div>
                                            <div className='flex justify-between items-center'>
                                                <p className='text-[#8A8A8E] tracking-[-0.14px] leading-[18.2px]'>Total a enviar</p>
                                                <p className='font-bold text-white tracking-[-0.44px]'>{FormatMontoPSE(totalPurchase, false, '.')}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        </div>

                        {/* Footer Buttons */}
                        <div className="px-6 pb-6 flex-shrink-0 flex justify-between">
                            <ButtonBack
                                Icon={Left}
                                onClick={() => setActiveConfimPurchase(false)}
                                label={'Volver'}
                            />
                            <ButtonWhite
                                loading={loading}
                                isDisabled={activeCompraFinal || contador <= 0}
                                onClick={() => setModalOTP(true)}
                                label={` ${activeCompraFinal ? `Ejecutar` : `Ejecutar ${contador}s`}`}
                            />
                        </div>
                    </motion.div>
                </div>



            </>}
        </>
    );
};

export default ConfirmPurchase;

